import React from "react";
import TopBar from "../components/sections/TopBar";
import Hero from "../components/sections/Hero";
import Gallery from "../components/sections/Gallery";
import HowItWorks from "../components/sections/HowItWorks";
import IdealFor from "../components/sections/IdealFor";
import Testimonials from "../components/sections/Testimonials";
import WhatYouGet from "../components/sections/WhatYouGet";
import Bonuses from "../components/sections/Bonuses";
import PriceOffer from "../components/sections/PriceOffer";
import FAQ from "../components/sections/FAQ";
import Footer from "../components/sections/Footer";
import MobileStickyCTA from "../components/sections/MobileStickyCTA";

const Home = () => {
  return (
    <div className="min-h-screen pb-16 md:pb-0">
      <TopBar />
      <Hero />
      <Gallery />
      <HowItWorks />
      <IdealFor />
      <Testimonials />
      <WhatYouGet />
      <Bonuses />
      <PriceOffer />
      <FAQ />
      <Footer />
      <MobileStickyCTA />
    </div>
  );
};

export default Home;
